export var NodeType;
(function (NodeType) {
    NodeType[NodeType["Plain"] = 0] = "Plain";
    NodeType[NodeType["Command"] = 1] = "Command";
    NodeType[NodeType["Debug"] = 2] = "Debug";
    NodeType[NodeType["Error"] = 3] = "Error";
    NodeType[NodeType["Info"] = 4] = "Info";
    NodeType[NodeType["Section"] = 5] = "Section";
    NodeType[NodeType["Verbose"] = 6] = "Verbose";
    NodeType[NodeType["Warning"] = 7] = "Warning";
    NodeType[NodeType["Group"] = 8] = "Group";
    NodeType[NodeType["EndGroup"] = 9] = "EndGroup";
    NodeType[NodeType["Icon"] = 10] = "Icon";
})(NodeType || (NodeType = {}));
